import TestAiRequest from './TestAiRequest';

export default TestAiRequest;
